import React from "react";
import { StatePanel, Skeleton } from "../../components/ui";

/**
 * The honest states a card shows instead of numbers: loading skeleton, an
 * error with Retry, or "nothing yet". Returns null when the data is ready.
 *
 * Stale-while-revalidate: once a card has numbers (fetched, kept from the
 * previous period, or painted from the user's stored copy) a later refetch
 * never swaps them for a skeleton or an error panel — the freshness line says
 * it is refreshing / couldn't refresh. Only a 403 replaces them: access was
 * taken away and the old numbers must not stay on screen.
 */
export function cardState(query, { what = "this", empty = false, emptyText, shape = "text", lines = 3 } = {}) {
  const hasData = query?.data !== undefined;
  const status = query?.error?.response?.status;
  if (query?.isError && status === 403) {
    return <StatePanel compact state="permission" title="Not available to you" description={query.error?.response?.data?.message || "Your role can't see this."} />;
  }
  if (!hasData && query?.isLoading) return <Skeleton shape={shape} lines={lines} />;
  if (!hasData && query?.isError) {
    return <StatePanel compact state="error" title={`Couldn't load ${what}`} description="Try again in a moment." onRetry={() => query.refetch()} />;
  }
  if (empty) return <p className="dash-empty">{emptyText || "Nothing here yet."}</p>;
  return null;
}
